const translations = {
  name: 'Nome',
  namePlural: 'Nome no plural',
  icon: 'Ícone',
  title: 'Tipo de locais',
  titleEdit: 'Editar tipo de locais',
  insertedAt: 'Criado em: ',
  updatedAt: 'Atualizado em: ',
  'edit.title': 'Editando',
  'create.title': 'Criando',
  placeType: 'tipo de local',
  requiredField: 'Campo obrigatório',
  successSave: 'Tipo de local salvo com sucesso!',
  errorSave: 'Ocorreu um erro ao salvar!'
}

export default translations
